import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, share } from 'rxjs/operators';
import { WebsocketService } from '~app/shared/websocket/websocket.service';
import { FluentBaseResult, FluentDatasource, IsLayerVisibleCb } from './fluent-interfaces';

@Injectable()
export class FluentWebsocketDatasourceService implements FluentDatasource {
  private readonly EQUIPMENT_ROOM_NAME = '13:gdpr:fluent';
  private readonly EQUIPMENT_MESSAGE_TARGET = 'vehicleLocations';
  private roomStatus: 'joined' | 'left' = 'left';

  constructor(
    private readonly ws: WebsocketService
  ) {

  }
  data$: Observable<FluentBaseResult>;

  init(isLayerVisibleCb: IsLayerVisibleCb) {
      // ensure room is joined after a disconnection, but only if the layer is visible
      const reconnectionEvents$ = this.ws.wsConnectionStatus$.pipe(
        filter(status => status === 'reconnected')
      );
      reconnectionEvents$.subscribe({
        next: () => {
          if(isLayerVisibleCb()) {
            this.joinEquipmentRoom();
          }
        }
      });

      this.data$ = this.ws.newWebsocketMessage$.pipe(
        filter(message => message.target === this.EQUIPMENT_MESSAGE_TARGET),
        map(message => message.body),
        share()
      );
  }

  subscribe(): void {
    if(this.roomStatus === 'joined') {
      return;
    }
    this.joinEquipmentRoom();
  }

  unsubscribe(): void {
    if(this.roomStatus === 'left') {
      return;
    }
    this.leaveEquipmentRoom();
  }

  private joinEquipmentRoom() {
    console.log('joining room');
    this.ws.sendPrimusMessage({
      action: 'join',
      room: this.EQUIPMENT_ROOM_NAME
    });
  }

  private leaveEquipmentRoom() {
    console.log('leaving room');
    this.ws.sendPrimusMessage({
      action: 'leave',
      room: this.EQUIPMENT_ROOM_NAME
    });
  }

}
